// helpers
import NFA from 'shared/helpers/analytics/NFAnalytics';
import { PDP_EVENTS } from 'shared/helpers/analytics/constants/pdpEvents';

export const trackEcomPolicy = (item: string) => {
  NFA.track({
    event: PDP_EVENTS.ECOM_CLICKED,
    dtmData: { ecomClickedValue: item },
  });
};
